import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './TopPhysiotherapyDealers.css';

const TopPhysiotherapyDealers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.primerehabindustries.in/#organization",
          "name": "Prime Rehab Industries",
          "url": "https://www.primerehabindustries.in",
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://primerehab.ascentbw.com/Image/Logo.png"
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.primerehabindustries.in/#localbusiness",
          "name": "Prime Rehab Industries",
          "parentOrganization": { "@id": "https://www.primerehabindustries.in/#organization" },
          "description": "Prime Rehab Industries is a leading manufacturer and dealer of physiotherapy and rehabilitation equipment in Tamil Nadu, supplying clinics, hospitals, and therapy centres across India.",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Chennai",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          },
          "telephone": "+919994351947",
          "email": "primerehaboffl@gmail.com",
          "url": "https://www.primerehabindustries.in",
          "sameAs": [
            "https://maps.app.goo.gl/placeholder"
          ],
          "areaServed": ["Tamil Nadu", "India"],
          "openingHours": "Mo-Sa 09:00-18:00"
        },
        {
          "@type": "Product",
          "name": "High Low Traction Table",
          "description": "Electrically height-adjustable traction table with secure traction lock, adjustable backrest up to 60 degrees, gas-spring movements, and rexine upholstery in multiple colour options. Height range 54 to 101 cm.",
          "brand": { "@id": "https://www.primerehabindustries.in/#organization" },
          "manufacturer": { "@id": "https://www.primerehabindustries.in/#organization" },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "85",
            "bestRating": "5",
            "worstRating": "1"
          },
          "review": [
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Dr. Ramesh Babu" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "reviewBody": "The traction tables from Prime Rehab are built to last. Electric height adjustment is smooth and the traction lock mechanism is solid. Exactly what our physiotherapy clinic needed.",
              "datePublished": "2025-04-15"
            },
            {
              "@type": "Review",
              "author": { "@type": "Person", "name": "Dr. Kavitha Nair" },
              "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
              "reviewBody": "We sourced all our treatment tables from Prime Rehab and the quality has been excellent. Reliable equipment and great support from the team. Highly recommended for any physiotherapy centre.",
              "datePublished": "2025-07-03"
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Is Prime Rehab Industries a manufacturer or a dealer of physiotherapy equipment?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Prime Rehab Industries is both a manufacturer and a direct dealer of physiotherapy and rehabilitation equipment. By manufacturing in-house and supplying directly, they ensure consistent quality and eliminate unnecessary middlemen, giving clinics better value."
              }
            },
            {
              "@type": "Question",
              "name": "Which physiotherapy equipment does Prime Rehab Industries supply in Tamil Nadu?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Prime Rehab Industries supplies over 100 models of physiotherapy equipment in Tamil Nadu including hi-low traction tables, tilting tables, Bobath tables, chiropractic drop tables, unweighing systems, and more, covering physiotherapy, chiropractic, orthopaedic, and neurological therapy needs."
              }
            },
            {
              "@type": "Question",
              "name": "Can Prime Rehab Industries supply equipment to both small clinics and large hospitals?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries supplies equipment to clinics of all sizes, from solo physiotherapy practices to large hospital rehabilitation departments. With 500+ clinics and hospitals served across India, they have experience meeting the needs of every type of healthcare facility."
              }
            },
            {
              "@type": "Question",
              "name": "Does Prime Rehab Industries offer custom physiotherapy equipment sizes?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes. Prime Rehab Industries offers custom equipment sizes to suit different clinic layouts, patient requirements, and space constraints. Contact the team with your specifications and they will manufacture equipment tailored to your exact needs."
              }
            }
          ]
        },
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.primerehabindustries.in"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Blog",
              "item": "https://www.primerehabindustries.in/blog"
            },
            {
              "@type": "ListItem",
              "position": 3,
              "name": "Top Physiotherapy Equipment Dealers in Tamil Nadu",
              "item": "https://www.primerehabindustries.in/blog/top-physiotherapy-equipment-dealers-tamil-nadu"
            }
          ]
        }
      ]
    };

    document.title = "Physiotherapy Equipment Dealers in Tamil Nadu | Prime Rehab";

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Prime Rehab Industries is among the top physiotherapy equipment dealers in Tamil Nadu, with 100+ models, 12+ years expertise, and 500+ clinics served.";

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = "https://www.primerehabindustries.in/blog/top-physiotherapy-equipment-dealers-tamil-nadu";

    let script = document.querySelector('#blog-schema');
    if (!script) {
      script = document.createElement('script');
      script.id = 'blog-schema';
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.innerHTML = JSON.stringify(schema);

    return () => {};
  }, []);

  return (
    <div className="layout-split-page">
      <Navbar />

      {/* Hero Section - Split Design */}
      <section className="split-hero">
        <div className="split-hero-container">
          <div className="split-hero-content">
            <span className="split-hero-tag">Rehabilitation Equipment Guide</span>
            <h1>Top Physiotherapy Equipment Dealers in Tamil Nadu</h1>
            <p>
              When you're setting up or expanding a physiotherapy clinic in Tamil Nadu, the equipment dealer you choose shapes everything the quality of your treatments, the confidence of your patients, and the daily efficiency of your team.
            </p>
            <div className="split-hero-buttons">
              <a href="/contact" className="split-btn-primary">Request a Quote</a>
              <a href="tel:+919994351947" className="split-btn-outline">+91 99943 51947</a>
            </div>
          </div>
          <div className="split-hero-image-wrapper">
            <img src="https://primerehab.ascentbw.com/Image/Product/Pro5.png" alt="Prime Rehab Industries High Low Traction Table — top physiotherapy equipment dealer in Tamil Nadu" />
          </div>
        </div>
      </section>

      {/* Intro Block */}
      <section className="split-intro">
        <div className="split-container">
          <div className="intro-card">
            <h2>The Prime Rehab Difference</h2>
            <p>
              A wrong choice means breakdowns, delays, and replacement costs you didn't budget for. The right choice means reliable equipment that works session after session, year after year.
            </p>
            <p>
              Prime Rehab Industries has built its reputation as one of Tamil Nadu's most trusted names in physiotherapy equipment by doing something most dealers can't: manufacturing every product in house. With 12+ years of experience, 100+ equipment models, and over 500 clinics served across India, the record speaks for itself.
            </p>
            <h3>What to Look for When Choosing a Physiotherapy Equipment Dealer</h3>
            <p>
              Not every supplier is the same. Before choosing a dealer for your clinic or hospital, it's worth asking a few important questions. Do they manufacture the equipment themselves or resell third party products? What is the build quality of the frames, upholstery, and mechanisms? Can they supply custom sizes for your specific space? And what happens if something needs attention after delivery? The answers to these questions separate dependable, long term partners from suppliers who move on after the sale is made.
            </p>
          </div>
        </div>
      </section>

      {/* Alternating Layout for Benefits */}
      <section className="split-benefits">
        <div className="split-container">
          <div className="section-title-center">
            <h2>Why Prime Rehab Industries Is a Top Physiotherapy Equipment Dealer in Tamil Nadu</h2>
            <p>The standard we hold ourselves to.</p>
          </div>

          <div className="benefit-row">
            <div className="benefit-text">
              <div className="benefit-num">1</div>
              <h3>A Manufacturer That Deals Directly</h3>
              <p>Prime Rehab Industries manufactures its own equipment and supplies it directly to clinics and hospitals. There are no intermediaries, no markups from third-party stockists, and no quality compromises from importing generic products. Every table, frame, and mechanism is built at their facility and delivered to your door with the consistency that only comes from end to end control.</p>
            </div>
          </div>

          <div className="benefit-row reverse">
            <div className="benefit-text">
              <div className="benefit-num">2</div>
              <h3>Over 100 Equipment Models</h3>
              <p>Whether your clinic specialises in orthopaedic physiotherapy, neurological rehabilitation, chiropractic care, or paediatric therapy, Prime Rehab has equipment designed specifically for that purpose. Browse the full range on the products page or download the product catalogue to see specifications for each model.</p>
            </div>
          </div>

          <div className="benefit-row">
            <div className="benefit-text">
              <div className="benefit-num">3</div>
              <h3>12+ Years of Clinical Manufacturing</h3>
              <p>Twelve years in physiotherapy equipment manufacturing means Prime Rehab has encountered every clinic requirement, every space constraint, and every clinical use case. That experience is built into every product — in the way frames are welded, the way height mechanisms are engineered, and the way upholstery is selected for long-term clinical use.</p>
            </div>
          </div>

          <div className="benefit-row reverse">
            <div className="benefit-text">
              <div className="benefit-num">4</div>
              <h3>Serving Clinics Across India</h3>
              <p>With over 500 clinics and hospitals served and more than 1,000 installations completed, Prime Rehab Industries is one of the few physiotherapy equipment dealers in Tamil Nadu with a track record of this scale. From solo physiotherapy practices in smaller towns to large hospital rehabilitation departments in Chennai, the range covers every requirement.</p>
            </div>
          </div>

          <div className="benefit-row">
            <div className="benefit-text">
              <div className="benefit-num">5</div>
              <h3>Custom Equipment</h3>
              <p>Off-the-shelf doesn't always fit. Prime Rehab Industries offers custom equipment sizes to match clinic dimensions, patient profiles, and therapist preferences. If your setup needs a table at a non standard height or a specific bed length, the team will manufacture it to your specification.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Banner */}
      <section className="quote-banner">
        <div className="split-container">
          <div className="quote-content">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"></path><path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"></path></svg>
            <blockquote>"The traction tables from Prime Rehab are built to last. Electric height adjustment is smooth and the traction lock mechanism is solid. Exactly what our physiotherapy clinic needed."</blockquote>
            <cite>— Dr. Ramesh Babu, Physiotherapist, Tamil Nadu</cite>
          </div>
        </div>
      </section>

      {/* Core Equipment Range (List style instead of grid) */}
      <section className="split-core-equipment">
        <div className="split-container">
          <div className="section-title-left">
            <h2>Core Physiotherapy Equipment Available from Prime Rehab</h2>
            <div className="title-underline"></div>
          </div>
          
          <div className="equipment-list">
            <div className="equipment-list-item">
              <h4>1. Hi-Low Traction and Treatment Tables</h4>
              <p>The High Low Traction Table (height 54–101 cm) features smooth electric height adjustment, a secure traction lock, gas-spring backrest movements, and rexine upholstery in multiple colour options. The High Low Two Fold Table and High Low 3-Fold Table offer additional sectional flexibility for a range of treatment positions.</p>
            </div>
            
            <div className="equipment-list-item">
              <h4>2. Tilting and Positioning Tables</h4>
              <p>The High Low Tilting Table combines motorized hi-low and tilting operation with harness support, a writing board, and a foot leg adjustment board ranging from +20° to -120°. The Fixed Height Tilting Table offers motorized tilt via remote control with a non slip foot step and safety harness both ideal for neurological and orthopaedic patients.</p>
            </div>
            
            <div className="equipment-list-item">
              <h4>3. Chiropractic Adjustment Tables</h4>
              <p>The Chiropractic Drop Table is built for precision. With a multi section drop mechanism, electric height control, and fully adjustable drop tension, it gives chiropractic practitioners the control they need for safe and effective spinal adjustments in a busy clinic environment.</p>
            </div>
            
            <div className="equipment-list-item">
              <h4>4. Gait Training and Unweighing Systems</h4>
              <p>The Unweighing System supports patients through standing and gait rehabilitation. With a motorized DC lifting mechanism, digital weight display, and safety harness support, it provides a controlled environment for patients recovering from neurological events, fractures, or major surgeries. An optional treadmill attachment enables advanced walking rehabilitation.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Second Quote Banner (Different Color) */}
      <section className="quote-banner dark">
        <div className="split-container">
          <div className="quote-content">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"></path><path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"></path></svg>
            <blockquote>"We sourced all our treatment tables from Prime Rehab and the quality has been excellent. Reliable equipment and great support from the team. Highly recommended for any physiotherapy centre."</blockquote>
            <cite>— Dr. Kavitha Nair, Physiotherapy Centre, Chennai</cite>
          </div>
        </div>
      </section>

      {/* Enquiry Block */}
      <section className="split-enquiry">
        <div className="split-container">
          <div className="enquiry-card">
            <h2>How to Enquire About Equipment from Prime Rehab Industries</h2>
            <p>
              Getting a quote is simple. Visit the contact page and share your clinic's requirements the products you need, any custom size preferences, and your location in Tamil Nadu. The team will respond with product details and specifications.
            </p>
            <p>
              You can also call directly on +91 99943 51947 or browse the full product range before reaching out. For a detailed look at dimensions and features, the product catalogue is available to download.
            </p>
            <div className="enquiry-actions">
              <a href="/products" className="split-btn-primary">View Products</a>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Accordion Style (visually) */}
      <section className="split-faq">
        <div className="split-container">
          <div className="section-title-center">
            <h2>Frequently Asked Questions</h2>
          </div>
          <div className="faq-boxes">
            <div className="faq-box">
              <h5>Is Prime Rehab Industries a manufacturer or a dealer of physiotherapy equipment?</h5>
              <p>Prime Rehab Industries is both a manufacturer and a direct dealer of physiotherapy and rehabilitation equipment. By manufacturing in-house and supplying directly, they ensure consistent quality and eliminate unnecessary middlemen, giving clinics better value.</p>
            </div>
            <div className="faq-box">
              <h5>Which physiotherapy equipment does Prime Rehab Industries supply in Tamil Nadu?</h5>
              <p>Prime Rehab Industries supplies over 100 models of physiotherapy equipment in Tamil Nadu including hi-low traction tables, tilting tables, Bobath tables, chiropractic drop tables, unweighing systems, and more, covering physiotherapy, chiropractic, orthopaedic, and neurological therapy needs.</p>
            </div>
            <div className="faq-box">
              <h5>Can Prime Rehab Industries supply equipment to both small clinics and large hospitals?</h5>
              <p>Yes. Prime Rehab Industries supplies equipment to clinics of all sizes, from solo physiotherapy practices to large hospital rehabilitation departments. With 500+ clinics and hospitals served across India, they have experience meeting the needs of every type of healthcare facility.</p>
            </div>
            <div className="faq-box">
              <h5>Does Prime Rehab Industries offer custom physiotherapy equipment sizes?</h5>
              <p>Yes. Prime Rehab Industries offers custom equipment sizes to suit different clinic layouts, patient requirements, and space constraints. Contact the team with your specifications and they will manufacture equipment tailored to your exact needs.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Footer Block */}
      <section className="split-footer-cta">
        <div className="split-container">
          <h2>Looking for a Reliable Physiotherapy Equipment Dealer in Tamil Nadu?</h2>
          <p>Skip the intermediaries. Prime Rehab Industries manufactures the equipment and delivers directly to your clinic or hospital in Tamil Nadu. Tell us what you need standard models or custom sizing and the team will take it from there.</p>
          <div className="cta-links">
            <a href="tel:+919994351947" className="split-btn-primary">Call: +91 99943 51947</a>
            <a href="https://maps.app.goo.gl/placeholder" target="_blank" rel="noopener noreferrer" className="split-btn-outline inverted">Find Us on Google Maps</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TopPhysiotherapyDealers;
